import WindowsInRowFormInstallationInformation from './WindowsInRowFormInstallationInformation';

export default WindowsInRowFormInstallationInformation;